import { Routes } from '@angular/router';
import { DashboardComponent } from '@views/dashboard/dashboard.component';
import {
  ConnectionpointSearchComponent
} from '@views/connectionpoint/connectionpoint-search/connectionpoint-search.component';
import { MissingPageComponent } from '@views/missing-page/missing-page.component';
import {
  ConnectionpointDetailsComponent
} from '@views/connectionpoint/connectionpoint-details/connectionpoint-details.component';
import { MeterpointDetailsComponent } from '@views/meteringpoint/meterpoint-details/meterpoint-details.component';
import { MeteringpointMeterComponent } from '@views/meteringpoint/meteringpoint-meter/meteringpoint-meter.component';
import {
  MeteringpointOverviewComponent
} from '@views/meteringpoint/meteringpoint-overview/meteringpoint-overview.component';
import {
  MeteringpointCalculationComponent
} from '@views/meteringpoint/meteringpoint-calculation/meteringpoint-calculation.component';
import {
  MeteringpointTimeseriesComponent
} from '@views/meteringpoint/meteringpoint-timeseries/meteringpoint-timeseries.component';
import {
  MeteringpointCoredataComponent
} from '@views/meteringpoint/meteringpoint-coredata/meteringpoint-coredata.component';
import {
  MeteringpointTransactionsComponent
} from '@views/meteringpoint/meteringpoint-transactions/meteringpoint-transactions.component';
import {
  MeteringpointPricingComponent
} from '@views/meteringpoint/meteringpoint-pricing/meteringpoint-pricing.component';
import {
  MeteringpointHistoryComponent
} from '@views/meteringpoint/meteringpoint-history/meteringpoint-history.component';
import {
  ManualTimeseriesImportComponent
} from '@views/meteringpoint/meteringpoint-csv-import/manual-timeseries-import.component';
import {
  ConnectionpointOverviewComponent
} from '@views/connectionpoint/connectionpoint-overview/connectionpoint-overview.component';
import {
  ConnectionpointMeteringpointOverviewComponent
} from '@views/connectionpoint/connectionpoint-meteringpoint-overview/connectionpoint-meteringpoint-overview.component';
import {
  ConnectionpointHistoryComponent
} from '@views/connectionpoint/connectionpoint-history/connectionpoint-history.component';
import { MeterframeOverviewComponent } from '@views/meterframes/meterframe-overview/meterframe-overview.component';
import { MeteringpointListComponent } from '@views/meteringpoint/meteringpoint-list/meteringpoint-list.component';
import { VeeListComponent } from '@views/vee/vee-list/vee-list.component';
import { VeeDetailsComponent } from '@views/vee/vee-details/vee-details.component';
import { VeeMeteringpointComponent } from '@views/vee/vee-meteringpoint/vee-meteringpoint.component';
import { VeeOverviewComponent } from '@views/vee/vee-overview/vee-overview.component';
import { ActorregisterListComponent } from '@views/actorregister/actorregister-list/actorregister-list.component';
import { SettlementDetailComponent } from '@views/settlement/settlement-detail/settlement-detail.component';
import {
  SettlementAggregatedMetereddataComponent
} from '@views/settlement/settlement-aggregated-metereddata/settlement-aggregated-metereddata.component';
import {
  SettlementAggregatedWholesaleComponent
} from '@views/settlement/settlement-aggregated-wholesale/settlement-aggregated-wholesale.component';
import {
  SettlementBillingInformationComponent
} from '@views/settlement/settlement-billing-information/settlement-billing-information.component';
import { SettingsOverviewComponent } from '@views/settings/settings-overview/settings-overview.component';
import { SettingsProfileComponent } from '@views/settings/settings-profile/settings-profile.component';
import { Error404Component } from '@views/errors/error-404/error-404.component';
import {
  ChargeinformationDetailsComponent
} from '@views/chargeInformation/chargeinformation-details/chargeinformation-details.component';
import {
  ChargeinformationOverviewComponent
} from '@views/chargeInformation/chargeinformation-overview/chargeinformation-overview.component';
import {
  ChargeinformationPricesOverviewComponent
} from '@views/chargeInformation/chargeinformation-prices-overview/chargeinformation-prices-overview.component';
import {
  ChargeinformationSetupPricesComponent
} from '@views/chargeInformation/chargeinformation-setup-prices/chargeinformation-setup-prices.component';
import {
  ChargeinformationBusinesstransactionsComponent
} from '@views/chargeInformation/chargeinformation-businesstransactions/chargeinformation-businesstransactions.component';
import {
  ChargeinformationSearchComponent
} from '@views/chargeInformation/chargeinformation-search/chargeinformation-search.component';
import { AuthLogoutComponent } from '@views/auth/auth-logout/auth-logout.component';
import { AuthFailedComponent } from '@views/auth/auth-failed/auth-failed.component';
import { AuthErrorComponent } from '@views/auth/auth-error/auth-error.component';
import { AuthLoginComponent } from '@shared/components/auth/auth-login/auth-login.component';
import { DashboardQueryComponent } from '@views/dashboard/list-views/dashboard-query/dashboard-query.component';
import {
  SettingsConfigurationComponent
} from '@views/settings/settings-configuration/settings-configuration.component';
import { SettingsTableComponent } from '@views/settings/settings-table/settings-table.component';
import {
  DashboardServicerequestComponent
} from '@views/dashboard/list-views/dashboard-servicerequest/dashboard-servicerequest.component';
import { Error401Component } from '@views/errors/error-401/error-401.component';
import { Error400Component } from '@views/errors/error-400/error-400.component';
import { hasRoleGuard } from '@app/core/guards/has-role.guard';
import {
  DashboardQueryHandlerComponent
} from '@views/dashboard/list-views/dashboard-query-handler/dashboard-query-handler.component';
import {
  DashboardTimeseriesMissingComponent
} from '@views/dashboard/list-views/dashboard-timeseries-missing/dashboard-timeseries-missing.component';
import {
  DashboardWaitingPriceComponent
} from '@views/dashboard/list-views/dashboard-waiting-price/dashboard-waiting-price.component';
import {
  DashboardChargeinformationOverdueComponent
} from '@views/dashboard/list-views/dashboard-chargeinformation-overdue/dashboard-chargeinformation-overdue.component';
import {
  DashboardUnbalancedQuantityComponent
} from "@views/dashboard/list-views/dashboard-unbalancedquantity/dashboard-unbalancedquantity.component";
import {
  DashboardTimeseriesLockedComponent
} from '@views/dashboard/list-views/dashboard-timeseries-locked/dashboard-timeseries-locked.component';
import {
  DashboardPriceStatusComponent
} from '@views/dashboard/list-views/dashboard-pricestatus/dashboard-pricestatus.component';
import {
  DashboardSystemOverviewComponent
} from '@views/dashboard/dashboard-system-overview/dashboard-system-overview.component';
import { DashboardTidsseriComponent } from '@views/dashboard/dashboard-tidsserier/dashboard-tidsserier.component';
import {
  DashboardServiceydelserComponent
} from '@views/dashboard/dashboard-serviceydelser/dashboard-serviceydelser.component';
import {
  DashboardMaalepunkterComponent
} from '@views/dashboard/dashboard-maalepunkter/dashboard-maalepunkter.component';
import {
  DashboardPriselementerComponent
} from '@views/dashboard/dashboard-priselementer/dashboard-priselementer.component';
import { DashboardElvarmeComponent } from '@views/dashboard/dashboard-elvarme/dashboard-elvarme.component';
import { DashboardDataHubCommunicationComponent } from '@views/dashboard/dashboard-datahub-communication/dashboard-datahub-communication.component';
import { MeteringpointCreateComponent } from '@views/meteringpoint/meteringpoint-create/meteringpoint-create.component';
import {
  DashboardChargeinformationRejectedComponent
} from '@views/dashboard/list-views/dashboard-chargeinformation-rejected/dashboard-chargeinformation-rejected.component';
import {
  ConnectionpointCreateComponent
} from '@shared/modals/connectionpoint/connectionpoint-create/connectionpoint-create.component';
import {
  DashboardUsedVerificationMeterReadingsComponent
} from '@views/dashboard/list-views/dashboard-used-verification-meter-readings/dashboard-used-verification-meter-readings-component';
import {
  DashboardMeteringpointWithSupplierComponent
} from '@views/dashboard/list-views/dashboard-meteringpoint-with-supplier/dashboard-meteringpoint-with-supplier.component';
import {
  DashboardMeteredDataNotCreatedComponent
} from '@views/dashboard/list-views/dashboard-metered-data-not-created/dashboard-metered-data-not-created.component';
import {
  DashboardServicerequestDisconnectComponent
} from '@views/dashboard/list-views/dashboard-servicerequest-disconnect/dashboard-servicerequest-disconnect.component';
import {
  DashboardServicerequestClosedownComponent
} from '@views/dashboard/list-views/dashboard-servicerequest-closedown/dashboard-servicerequest-closedown.component';
import {
  DashboardServicerequestReopenComponent
} from '@views/dashboard/list-views/dashboard-servicerequest-reopen/dashboard-servicerequest-reopen.component';
import {
  DashboardServicerequestDeliverydisconnectComponent
} from '@views/dashboard/list-views/dashboard-servicerequest-deliverydisconnect/dashboard-servicerequest-deliverydisconnect.component';
import {
  DashboardServicerequestMetercontrolComponent
} from '@views/dashboard/list-views/dashboard-servicerequest-metercontrol/dashboard-servicerequest-metercontrol.component';
import {
  DashboardDeviatingMetersComponent
} from '@views/dashboard/list-views/dashboard-deviating-meters/dashboard-deviating-meters-component';
import {
  DashboardExceedingPowerLimitsComponent
} from '@views/dashboard/list-views/dashboard-exceeding-power-limits/dashboard-exceeding-power-limits.component';
import {
  DashboardMeteringPointQuadrantMismatchComponent
} from '@views/dashboard/list-views/dashboard-metering-point-quadrant-mismatch/dashboard-metering-point-quadrant-mismatch-component';
import {
  DashboardExpiringConnectionRightsComponent
} from '@views/dashboard/list-views/dashboard-expiring-connection-rights/dashboard-expiring-connection-rights.component';
import { AuthRoles } from '@app/api/dmc';
import { authenticatedGuard } from '@app/core/guards/authenticated.guard';
import { devEnvironmentGuard } from '@app/core/guards/dev-environment.guard';
import { unsavedChangesGuard } from '@app/core/guards/unsaved-changes.guard';
export const routes: Routes = [
  // Home
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // Dashboard
  { path: 'dashboard', component: DashboardComponent, canActivate: [authenticatedGuard], children: [
      { path: '', pathMatch: 'full', redirectTo: () => DashboardComponent.resolveLastTab() },
      { path: 'tidsserier', component: DashboardTidsseriComponent },
      { path: 'serviceydelser', component: DashboardServiceydelserComponent },
      { path: 'maalepunkter', component: DashboardMaalepunkterComponent },
      { path: 'priselementer', component: DashboardPriselementerComponent },
      { path: 'elvarme', component: DashboardElvarmeComponent },
      { path: 'system', component: DashboardSystemOverviewComponent },
      { path: 'datahub', component: DashboardDataHubCommunicationComponent },
    ] },

  // Dashboard - Query
  { path: 'dashboard/query', component: DashboardQueryComponent, canActivate: [authenticatedGuard], children: [
      { path: 'failedautomations', component: DashboardWaitingPriceComponent },
      { path: 'overduepending', component: DashboardChargeinformationOverdueComponent },
      { path: 'rejectedchargeinformation', component: DashboardChargeinformationRejectedComponent },
      { path: 'newmeteringpointwithsupplier', component: DashboardMeteringpointWithSupplierComponent },
      { path: 'metereddatanotcreated', component: DashboardMeteredDataNotCreatedComponent },
      // Service Requests
      { path: 'disconnect', component: DashboardServicerequestDisconnectComponent },
      { path: 'deliverydisconnect', component: DashboardServicerequestDeliverydisconnectComponent },
      { path: 'closedown', component: DashboardServicerequestClosedownComponent },
      { path: 'reopen', component: DashboardServicerequestReopenComponent },
      { path: 'metercontrol', component: DashboardServicerequestMetercontrolComponent },
      { path: 'exceedingpowerlimits', component: DashboardExceedingPowerLimitsComponent },
      { path: 'expiringconnectionrights', component: DashboardExpiringConnectionRightsComponent },
      // Handler
      { path: ':query', component: DashboardQueryHandlerComponent },
    ]
  },
  { path: 'dashboard/unbalancedquantity', component: DashboardUnbalancedQuantityComponent, canActivate: [authenticatedGuard] },
  { path: 'dashboard/pricestatus', component: DashboardPriceStatusComponent, canActivate: [authenticatedGuard] },

  // Dashboard - Service request
  { path: 'dashboard/servicerequest', component: DashboardServicerequestComponent, canActivate: [authenticatedGuard] },

  // Dashboard - Timeseries
  { path: 'dashboard/timeseries', component: DashboardQueryComponent, canActivate: [authenticatedGuard], children: [
      { path: 'missing', component: DashboardTimeseriesMissingComponent },
      { path: 'locked', component: DashboardTimeseriesLockedComponent },
      { path: 'usedverificationmeterreadings', component: DashboardUsedVerificationMeterReadingsComponent },
      { path: 'deviatingmeters', component: DashboardDeviatingMetersComponent },
      { path: 'quadrantmismatch', component: DashboardMeteringPointQuadrantMismatchComponent }
    ]
  },

  // ConnectionPoint
  { path: 'connectionpoint', component: ConnectionpointSearchComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.ConnectionPointReader, AuthRoles.ConnectionPointWriter])] },
  { path: 'connectionpoint/create', component: ConnectionpointCreateComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.ConnectionPointReader, AuthRoles.ConnectionPointWriter])], canDeactivate: [unsavedChangesGuard] },
  {
    path: 'connectionpoint/:id', component: ConnectionpointDetailsComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.ConnectionPointReader, AuthRoles.ConnectionPointWriter])], children: [
      { path: '', component: ConnectionpointOverviewComponent, pathMatch: 'full' },
      { path: 'meterframe', component: MeterframeOverviewComponent },
      { path: 'meteringpoints', component: ConnectionpointMeteringpointOverviewComponent },
      { path: 'history', component: ConnectionpointHistoryComponent },
      { path: ':category', component: ConnectionpointDetailsComponent },
    ]
  },

  // MeteringPoint - List and Create
  { path: 'meteringpoint', component: MeteringpointListComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.MeteringPointReader, AuthRoles.MeteringPointWriter])] },
  { path: 'meteringpoint/create', component: MeteringpointCreateComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.MeteringPointReader, AuthRoles.MeteringPointWriter])], canDeactivate: [unsavedChangesGuard] },

  // CSV Upload Metered Data - Manual Timeseries
  {
    path: 'meteringpoint/upload', component: ManualTimeseriesImportComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.MeteringPointReader, AuthRoles.MeteringPointWriter])]
  },

  // MeteringPoint - Detail Page
  {
    path: 'meteringpoint/:id', component: MeterpointDetailsComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.MeteringPointReader, AuthRoles.MeteringPointWriter])], children: [
      { path: '', component: MeteringpointOverviewComponent, pathMatch: 'full' },
      { path: 'meter', component: MeteringpointMeterComponent },
      { path: 'calculation', component: MeteringpointCalculationComponent },
      { path: 'timeseries', component: MeteringpointTimeseriesComponent },
      { path: 'coredata', component: MeteringpointCoredataComponent },
      { path: 'transactions', component: MeteringpointTransactionsComponent },
      { path: 'pricing', component: MeteringpointPricingComponent },
      { path: 'history', component: MeteringpointHistoryComponent },
    ],
  },

  // VEE
  { path: 'vee', component: VeeListComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.VEEReader, AuthRoles.VEEWriter])] },
  {
    path: 'vee/:id', component: VeeDetailsComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.VEEReader, AuthRoles.VEEWriter])], children: [
      { path: '', component: VeeOverviewComponent, pathMatch: 'full' },
      { path: 'meteringpoints', component: VeeMeteringpointComponent }
    ]
  },

  // Charge Information
  { path: 'chargeinformation', component: ChargeinformationSearchComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.ChargeInformationReader, AuthRoles.ChargeInformationWriter])] },
  {
    path: 'chargeinformation/:id', component: ChargeinformationDetailsComponent, canActivate: [authenticatedGuard, hasRoleGuard([AuthRoles.ChargeInformationReader, AuthRoles.ChargeInformationWriter])], children: [
      { path: '', component: ChargeinformationOverviewComponent, pathMatch: 'full' },
      { path: 'prices', component: ChargeinformationPricesOverviewComponent },
      { path: 'setupprices', component: ChargeinformationSetupPricesComponent },
      { path: 'businesstransactions', component: ChargeinformationBusinesstransactionsComponent },
    ]
  },

  // Actors
  { path: 'actors', component: ActorregisterListComponent, canActivate: [authenticatedGuard] },

  // Settlement
  {
    path: 'settlement', component: SettlementDetailComponent, canActivate: [authenticatedGuard], children: [
      { path: '', component: SettlementAggregatedMetereddataComponent },
      { path: 'wholesale', component: SettlementAggregatedWholesaleComponent },
      { path: 'billing', component: SettlementBillingInformationComponent }
    ]
  },

  // Settings
  { path: 'settings', component: SettingsOverviewComponent, canActivate: [authenticatedGuard], children: [
      { path: '', component: SettingsProfileComponent, pathMatch: 'full' },
      { path: 'table', component: SettingsTableComponent },
      { path: 'configuration', component: SettingsConfigurationComponent },
    ]
  },

  // Auth
  { path: 'auth', component: AuthLoginComponent },
  { path: 'auth/logout', component: AuthLogoutComponent },
  { path: 'login-failed', component: AuthFailedComponent },
  { path: 'auth/error', component: AuthErrorComponent },
  {
    path: 'dev-login',
    canActivate: [devEnvironmentGuard],
    loadComponent: () => import('./views/dev-login/dev-login.component').then(m => m.DevLoginComponent),
  },

  // Errors
  { path: 'error', component: MissingPageComponent, children: [
      { path: '400', component: Error400Component },
      { path: '401', component: Error401Component },
      { path: '404', component: Error404Component },
    ]
  },

  // Page not found
  { path: '**', component: Error404Component },
];
